import { Component, createRef } from "@wordpress/element";

export default class Accordion extends Component {
	constructor() {
		super(...arguments);

		this.accordionRef = createRef();
		this.state = {
			active: 0,
			currentFocus: 0,
			isFocused: false,
		};
	}

	updateActiveIdx(active, takeFocus = false) {
		// this.setState({ active, currentFocus: active });
		this.setState({ active });
	}

	render() {
		// console.log(78, this.props);
		let { children } = this.props;

		if (!this.props.isAdmin) {
			children = Array.isArray(children) ? children : [children];
			children = children.map((child, idx) => {
				return wp.element.cloneElement(child, {
					active: this.state.active === idx,
					anchor: this.props.anchor,
					idx,
					currentFocus: this.state.currentFocus,

					onClick: (e, idx) => {
						e.preventDefault();

						const newActiveIdx = this.state.active === idx ? -1 : idx;
						this.updateActiveIdx(newActiveIdx, true);
					},
				});
			});
		}

		return (
			<div
				data-react="Accordion"
				data-props={JSON.stringify(this.props.attributes)}
				className={`accordion accordion-wrapper ${this.props.className}`}
				ref={this.accordionRef}
			>
				{children}
			</div>
		);
	}
}
